import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const EarnedCreditsHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Earned credits'>
    Total number of credits that you have received a passing grade for. It does not include current term credits.
  </HelpModal>